module.exports = __webpack_public_path__ + "img/truck.486ffaad.png";